function limitArray(value, maxItems) {
  if (!Array.isArray(value)) return [];
  return value.slice(0, maxItems);
}

function summarizeScappContext(scappContext) {
  if (!scappContext || typeof scappContext !== "object") {
    return null;
  }

  const digest =
    scappContext.digest && typeof scappContext.digest === "object"
      ? scappContext.digest
      : {};
  const viewSignature =
    scappContext.viewSignature && typeof scappContext.viewSignature === "object"
      ? scappContext.viewSignature
      : {};
  const coverage =
    scappContext.coverage && typeof scappContext.coverage === "object"
      ? scappContext.coverage
      : {};

  return {
    state: scappContext.state || "unknown",
    coverage: {
      visibleEntityCount: coverage.visibleEntityCount || 0,
      loadedDayCount: coverage.loadedDayCount || 0,
      truncated: Boolean(coverage.truncated),
      warnings: limitArray(coverage.warnings, 8),
    },
    selectionSummary: {
      selectedValues: limitArray(viewSignature.entities?.selected, 8),
      selectedEntities: limitArray(viewSignature.entities?.visible, 8),
      selectedEntityName: viewSignature.selectedEntityName || null,
      selectedDay: viewSignature.selectedDay || null,
      layoutLevel: viewSignature.layoutLevel || null,
      comparisonMode: viewSignature.comparisonMode || null,
    },
    digest: {
      highlights: limitArray(digest.highlights, 8),
      rankingSummary: limitArray(digest.rankingSummary, 6),
      viewNotes: limitArray(digest.viewNotes, 8),
      entityTable: limitArray(digest.entityTable, 8),
      dailyRollup: limitArray(digest.dailyRollup, 8),
    },
  };
}

export function buildVisibleDigest({ viewContext, scappContext, userContext }) {
  return {
    version: 1,
    service: viewContext?.service || "",
    module: viewContext?.module || "",
    view: viewContext?.view || "",
    identity: {
      username: userContext?.username || "",
      cargo: userContext?.cargo || "",
    },
    selectionSummary: {
      entities: viewContext?.entities || {},
      filters: viewContext?.filters || {},
      uiState: viewContext?.uiState || {},
      selectedValues: limitArray(
        scappContext?.viewSignature?.entities?.selected,
        8
      ),
      selectedEntities: limitArray(
        scappContext?.viewSignature?.entities?.visible,
        8
      ),
      selectedEntityName:
        scappContext?.viewSignature?.selectedEntityName || null,
      selectedCenters: limitArray(
        scappContext?.viewSignature?.entities?.visible,
        8
      ),
    },
    scapp: summarizeScappContext(scappContext),
  };
}
